/** An app opened from a home screen, in its own window. */
export function runsInstalled(): boolean {
  return (
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

/** iPadOS says it is a Mac; the touch points are what give it away. */
export function isApple(): boolean {
  return (
    /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

/**
 * Whether signing in has to be done by leaving the page instead of in a window.
 *
 * Only where the app that leaves is the one that comes back, and that means an
 * installed app on anything but an iPhone. An iPhone hands the trip to Safari:
 * Safari returns to the sign-in page with none of the state the app left behind
 * — the "missing initial state" screen — and whoever signs in ends up signed in
 * to Safari and not to the app. Better to ask for a window there, even one the
 * phone may refuse to open.
 */
export function signsInByLeaving(): boolean {
  return runsInstalled() && !isApple();
}
